<template>
    <v-toolbar 
        app
        clipped-left
        dense
        flat
        dark
    >
        <v-toolbar-side-icon @click.native="NavDrawer.toggle()"></v-toolbar-side-icon>
            <v-menu offset-y>
                <v-toolbar-title class="white--text font-weight-light" slot="activator">
                    {{m.toolbar_title}} <v-icon>arrow_drop_down</v-icon>
                </v-toolbar-title>
                <v-list dense>
                    <v-list-tile @click="onReportTypeSelect('standard')" href="https://data.csueastbay.edu/">
                        <v-list-tile-title>Standard Reports</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="onReportTypeSelect('operations')" href="https://data.csueastbay.edu/internal">
                        <v-list-tile-title>Internal Reports (requires login)</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        <!-- <v-toolbar-title class="white--text">
            <span class="font-weight-light">Pioneer Insights<span v-if="Insights.app.mode === 'operations'">: Internal Reports</span></span>
        </v-toolbar-title> -->
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <v-divider vertical></v-divider>
            <v-btn flat small class="font-weight-light hidden-sm-and-down">Version 0.5</v-btn>
            <v-divider vertical></v-divider>
            <v-btn v-if="Insights.app.mode === 'operations'" flat small class="font-weight-light" :href="m.exit_href">
                Logout &nbsp;<v-icon>exit_to_app</v-icon>
            </v-btn>
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
import Insights from '../models/Insights'
import NavDrawer from '../models/App.NavDrawer'

export default {
    data(){
        return{
            Insights,
            NavDrawer,
            m:{
                toolbar_title: (Insights.app.mode === "operations") ? "PI: Internal Reports" : "Pioneer Insights",
                exit_href: (Insights.app.mode === "operations") ? "https://data.csueastbay.edu/internal/logout.php" : "https://data.csueastbay.edu/internal"
            }
        }
    },
    methods:{
        onReportTypeSelect(){
            //Purposefully blank
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
